import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { db } from '../../services/firebase_services';
import { CommunityModel } from '../../models/CommunityModel';
import { shadow } from '../../assets/styles/styles';
import { BorderBottom } from '@mui/icons-material';

export function ViewCommunity() {
  const { id } = useParams();

  const [community, setCommunity] = useState<undefined | CommunityModel>(
    undefined
  );
  const [members, setMembers] = useState(0);
  const [loading, setLoading] = useState(false);

  async function getCommunity() {
    try {
      setLoading(true);
      let comm = (
        await db.ref('/new_data/community_data/communities/' + id).once('value')
      ).val();

      console.log(comm);
      if (comm !== null) {
        setCommunity(comm);

        let comms = await db
          .ref('/new_data/community_data/community_users/' + comm.communityId)
          .orderByChild('active')
          .equalTo(true)
          .once('value');

        setMembers(comms.numChildren());
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (id) {
      getCommunity();
    }
  }, [id]);
  return (
    <Grid
      container
      justifyContent={'center'}
      alignContent={loading ? 'center' : 'flex-start'}
      style={{
        backgroundColor: 'white',
      }}
    >
      {loading ? (
        <Grid
          container
          sx={{ height: '100vh' }}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <CircularProgress />
        </Grid>
      ) : !community ? (
        <Grid
          container
          item
          xs={12}
          justifyContent={'center'}
          alignItems={'center'}
          height={'100vh'}
        >
          <Grid
            item
            container
            xs={12}
            sm={6}
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            rowSpacing={2}
          >
            <Grid item>
              <img src={'/static/searching.png'} width={400} />
            </Grid>
            <Grid item>
              <Typography variant={'h4'}>Private Community</Typography>
            </Grid>
            <Grid item>
              <Typography variant={'body1'}>
                View this community in-app to join / request to join.
              </Typography>
            </Grid>
            <></>
            <Grid item>
              <Button
                variant={'contained'}
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                Take me home!
              </Button>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={6}
          style={{
            boxShadow: '10px 10px 20px 15px grey',
            borderRadius: 10,
            marginTop: '15px',
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              height: 'calc(100vh - 30px)',
              borderRadius: 10,
              overflow: 'hidden',
            }}
          >
            <Grid
              item
              container
              xs={12}
              justifyContent={'center'}
              style={{
                backgroundImage: `url(${'/static/login-bground.jpg'})`,
                backgroundSize: 'cover',
              }}
              spacing={3}
              padding={4}
            >
              <Grid item>
                <div
                  style={{
                    width: 150,
                    height: 150,
                    backgroundImage: `url("${community?.imageUrl}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: 5,
                  }}
                />
              </Grid>
              <Grid item container style={{ flex: 1 }} flexDirection={'column'}>
                <Grid item container justifyContent={'flex-end'}>
                  <Grid
                    item
                    style={{
                      padding: '5px 10px',
                      borderRadius: 50,
                      border: '2px solid white',
                    }}
                  >
                    <Typography
                      variant="body1"
                      color="white"
                      style={{ fontFamily: 'Urbanist' }}
                    >
                      {members} Buddies
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item container alignContent={'center'} marginTop={1}>
                  <Typography variant="h4" fontWeight={'bold'} color="white">
                    {community?.name}
                  </Typography>
                  <Typography variant="body1" color="white">
                    {community?.desc}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              container
              xs={12}
              justifyContent={'center'}
              style={{ marginTop: '15px' }}
            >
              <Grid
                container
                item
                xs={10}
                sm={9}
                lg={8}
                justifyContent={'center'}
                flexDirection={'row'}
                maxWidth={'260px'}
                spacing={5}
                paddingTop={5}
              >
                <div style={{ position: 'relative' }}>
                  <div
                    style={{
                      width: 150,
                      height: 250,
                      backgroundImage: `url(${'/static/comm_app.png'})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      borderRadius: 5,
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: 82.7,
                      left: 15.3,
                      width: 30,
                      height: 30,
                      borderRadius: 2,
                      backgroundImage: `url("${community?.imageUrl}")`,
                      backgroundSize: 'cover',
                    }}
                  ></div>

                  <div
                    style={{
                      position: 'absolute',
                      top: 83.2,
                      left: 50,
                      width: 80,
                      height: 25,
                      borderRadius: 2,
                      flexDirection: 'column',
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="white"
                      fontSize={8}
                      fontWeight={'bold'}
                      lineHeight={1.2}
                    >
                      {community.name}
                    </Typography>
                    <Typography variant="body1" color="white" fontSize={4}>
                      {community.desc}
                    </Typography>
                  </div>
                </div>

                <Grid item container justifyContent={'center'}>
                  <Typography variant="h5" fontWeight={'bold'}>
                    {community!.name}
                  </Typography>
                  <Typography textAlign={'center'}>
                    Keep up with everything {community!.name} is up to within
                    the RouteBuddies app.
                  </Typography>
                </Grid>
                <Button
                  onClick={() => {
                    window.location.href =
                      'https://routebuddies.com/?appTrigger=true';
                  }}
                  variant="contained"
                  style={{
                    padding: 15,
                    borderRadius: 40,
                    marginTop: 30,
                    width: 250,
                  }}
                >
                  <Typography fontWeight={'bold'}>Download the app</Typography>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
